import { api, apiStore, actions, getServerErrorMessage } from "../services";

const isAuth = /\/(login|register)$/;

let isUpgradeRequiredDetected = false;

api.subscribe(async function listener(req, res) {
  if (res.status === 401) {
    actions.stopSession();
  }

  if (!isUpgradeRequiredDetected && res.status === 426) {
    isUpgradeRequiredDetected = true;

    alert("A new version of the app is available.");

    // TODO: web only
    document.location.reload();
  }

  // actions.setUpgradeAvailable(res.status === 426);
  // actions.setMaintenance(res.status === 503);

  const isMutation =
    req.method === "POST" ||
    req.method === "PUT" ||
    req.method === "PATCH" ||
    req.method === "DELETE";

  const isError = res.status >= 400;

  if (res.status === 422) {
    alert(await getServerErrorMessage(res));
  } else if (!isError && isMutation && !isAuth.test(req.url)) {
    // Invalidate on any mutation success other than auth endpoints
    apiStore.invalidateQueries();
  }
});
